<div class="molecular-weight-container">
  <div class="molecular-weight-item-container">
    <div class="molecular-weight-item-input-container">
      <mat-form-field appearance="outline" class="molecular-weight-form-field">
        <mat-label>{{ formFieldTitle }}</mat-label>
        <input matInput #molecularWeightInput [(ngModel)]="molecularWeight"
          class="molecular-weight molecular-weight-item-input"
          (keyup.enter)="updateMolecularWeight($event)" (keyup.escape)="cancelUpdate()"
          (blur)="updateMolecularWeight($event)" />
        <mat-icon matSuffix (mousedown)="clearMolecularWeightInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError(formFieldName, 'required')">
      This is a required field.
    </div>
    <div class="input-error" *ngIf="!hasFieldValidationError(formFieldName, 'required') && hasFieldValidationError(formFieldName, 'pattern')">
      {{ infoText }}
    </div>
  </div>
  <div class="molecular-weight-info molecular-weight-info-text">{{ infoText }}</div>
</div>